import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between gap-2 sm:gap-0">
          {/* Copyright */}
          <div>
            <p className="text-sm text-gray-600">
              © 2026 UoR FoE - Maintenance, Requests and Complaints Management System
            </p>
          </div>
          
          {/* Powered by */}
          <div className="flex items-center space-x-2">
            <span className="text-xs text-gray-500">Powered by</span>
            <a
              href="https://scorpion-xweb.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded px-1"
            >
              Scorpion X
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;